import { TaiLieu } from "../nhanvien/TaiLieu";
import { LoiViPhamCaNhan } from "./KPICaNhan";

export class KPIPhongBanPagingResponse {
    "data": Array<KPIPhongBanResponse>;
    "nhanViens": Array<any>;
}

export class KPIPhongBanResponse{
"idKPICaNhan": number;
"thangNam": Date;
"xepLoai": string;
"xepLoaiDuKien": string;
"idNhanVien": number;
"hoTen": string;
"tenChucVu": string;
"idDonVi": number;
"thuTuDonVi": number;
"thuTuChucVu": number;
"thuTuNhanVien": number;
"tenDonVi": string;
"ghiChuDonVi": string; // tên phòng ban hiển thị trên biểu đồ (DonVi.GhiChu)
"trangThai": number;
"tuDanhGia": number;
"lanhDaoPhong": number | null;
"lanhDaoPhuTrach": number | null;
"idDonViPhuTrach": number | null;
"lanhDaoDonVi": number | null;
 "soCongViec": number;
 "truoc": number;
 "dung": number;
 "tre": number;
 "loi": number
 "dangThucHien": number;
"diemDanhGia": number;
"truocs": Array<any>;
"dungs": Array<any>;
"tres": Array<any>;
"lois": Array<any>;
"dangThucHiens": Array<any>;
"chuaHoanThanhs": Array<any>;
"loiViPhams": Array<LoiViPhamCaNhan>; // lỗi vi phạm trong tháng
"theoDoiCongViecs": Array<TheoDoiCongViec>; // theo dõi vòng đời công việc trong tháng
}

export class TheoDoiCongViec {
    "id": number;
    "idCha": number;
    "idNhom": number; // Id bản ghi gốc của chuỗi công việc (gom nhóm theo công việc)
    "tenCongViec": string;
    "thangNam": string;
    "tienDo": number;
    "tenNVGiao": string;
}

export class KPIThang {
    "id": number;
    "noiDung": string;
    "thangNam": Date;
    "trangThai": number;
    "dsTaiLieu": Array<TaiLieu>;
    "trinhPhoCVP": boolean;
    "idNVKhoiTao": number;
}
export class ThongKeKPIResponse {
    "data": Array<KPIPhongBanResponse> = [];
    "theoDoiGiaoViecs": Array<TheoDoiCongViec> = [];
}
